import { useTranslate } from '@growtherapy/i18n';
import { Body } from '@growtherapy/sprout-ui';

export function ResourcesTable({ resources }: { resources: string[] }): JSX.Element {
  const t = useTranslate();

  return (
    <div>
      <Body.Default emphasis>{t('telehealth-core:providerIntersessionSummary.resources')}</Body.Default>
      {resources.length ? (
        resources.map((resource, index) => (
          <div key={index} className='flex flex-row border-b py-2 rebrand:border-border-subtle justify-between w-full'>
            <Body.Small className='rebrand:text-text-muted'>{resource}</Body.Small>
          </div>
        ))
      ) : (
        <Body.Small className='rebrand:text-text-muted'>
          {t('telehealth-core:providerIntersessionSummary.tryAssigningResources')}
        </Body.Small>
      )}
    </div>
  );
}
